import { ReactComponent as FlagIcon } from "./svg/it-flag.svg";
import "../flag-icon.scss";

export const ITFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
